import React, { memo } from 'react'
import { List } from '@mui/material'
import { RouteListProps } from './RouteList.types'
import RouteListItem from './RouteListItem'

function RouteList({ routes, inner }: RouteListProps) {
    return (
        <List dense disablePadding>
            {routes
                .filter((route, _index) => !route.hidden)
                .map((route, index) => (
                    <RouteListItem
                        key={index}
                        route={route}
                        index={index}
                        inner={inner}
                    />
                ))}
        </List>
    )
}

export default memo(RouteList)
